
import { currentDate } from "utils/date-utils";
import GenericHttpService from "./GenericHttpService";
import http from "utils/HttpCommon";
import { normalize } from "utils/stringUtils";

const endpoint = 'pvl';

const SITUACAO_RASCUNHO = { "id": 510, "codigo": "RASCUNHO" };
const SITUACAO_DEFERIDA = {"id": 515, "codigo": "DEFERIDO"};
const SITUACAO_INDEFERIDA = {"id": 516, "codigo": "INDEFERIDO"};
const SITUACAO_RETIFICACAO = {"id": 512, "codigo": "RETIFICACAO"};
const SISTEMA_ORIGEM_SICONFI = { "id": 543, "codigo": "SICONFI" };

const emptyObject = {
    id: null,
    idSiconfiDivida: '',
    oc: {
        identificadorSiconfi: '',
        credor: {
          nome: ''  
        },
        devedorInfo: {
          nome:''  
        },
        moeda: {
          nome: ''
        }
    },    
    nup: '',
    sistemaOrigem: SISTEMA_ORIGEM_SICONFI,
    identificadorSiconfi: '',
    situacao:SITUACAO_RASCUNHO,
    dataSituacao: currentDate().toString(),
    tramites:[],
    analises: [],
    listaSituacoes: [],
    listaSituacoesSadipem: [],
    especiesPVL: [],
    etiquetas: [],
    algumaEtiqueta: [],
    cadaEtiqueta: [],
    possuiGarantia: null,
 };

const getDadosAnalise = (tipoAnalise) => {
    return http.get(`/${endpoint}/obter-dados-analise/${tipoAnalise.id}`);

}

// TODO levar para o ItemVerificacaoService
const getComentariosPadrao = (idItemVerificacao, idSubitem) => {
  //console.log("idItemVerificacao na linha 42 do PVLService", idItemVerificacao);
  //console.log("idSubitem na linha 43 do PVLService", idSubitem);
  
  if(idItemVerificacao){
    return http.get(`/${endpoint}/obter-comentarios-padrao?idItem=${idItemVerificacao}&idSubitem=${idSubitem}`);
  }
  
}

const exportarAnalise = async (idPvl, nomeEnte) => {
    nomeEnte = normalize(nomeEnte).replaceAll(" ", "");
    const response = await http.get(`/pvl-documento/exportar-analise/${idPvl}`, {
        responseType: 'blob',
    });
    
    // Criar um link temporário para download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Analise_${idPvl}-${nomeEnte}.pdf`); // Nome do arquivo a ser baixado
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const exportarAnaliseGarantia = async (idPvl, nomeEnte) => {
    const response = await http.get(`/pvl-documento/exportar-analise-garantia/${idPvl}`, {
        responseType: 'blob',
    });
    
    // Criar um link temporário para download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Analise_Garantia_${idPvl}-${nomeEnte}.pdf`); // Nome do arquivo a ser baixado
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const excluirDocumentoPVL = (id) => {
  return http.delete(`/pvl-documento/excluir/${id}`);
}

export default {
    ...GenericHttpService(endpoint),
    getEmptyObject: () =>({...emptyObject}),
    getDadosAnalise,
    getComentariosPadrao,
    exportarAnalise,
    exportarAnaliseGarantia,
    excluirDocumentoPVL,
    SITUACAO_RASCUNHO,
    SITUACAO_DEFERIDA,
    SITUACAO_INDEFERIDA,
    SITUACAO_RETIFICACAO
}


